'use es6';

import memoize from 'react-utils/memoize';
/**
 * @param  {string}
 * @return {string}
 */

const capitalize = str => str[0].toUpperCase() + str.slice(1);
/**
 * @param  {string}
 * @return {string}
 */


const uncapitalize = str => str[0].toLowerCase() + str.slice(1);
/**
 * @param  {string}
 * @return {string}
 */


export const getDefaultPropName = memoize(field => `default${capitalize(field)}`);
/**
 * @param  {string}
 * @return {string}
 */

export const getOnChangeName = memoize(field => {
  if (field === 'value') {
    return 'onChange';
  }

  return `on${capitalize(field)}Change`;
});
/**
 * @param  {string}
 * @return {string}
 */

export const getPropFromDefaultName = memoize(defaultProp => {
  if (!defaultProp) {
    return '';
  }

  return uncapitalize(defaultProp.replace('default', ''));
});